import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from 'src/app/config/variable';
import { AppUserService } from 'src/app/services/app-user.service';
@Component({
    selector: 'xsk-greet-book',
    templateUrl: './greet-book.component.html',
    styleUrls: ['./greet-book.component.scss'],
    standalone: false
})
export class GreetBookComponent implements OnInit {
  globalVariable = GlobalVariable;
  content: any;
  constructor(private modalController: ModalController,
              private appUserService: AppUserService) { }

  clickGreet(type: boolean) {
    if (!type) {
      this.modalController.dismiss(type, 'cancel');
      return;
    }
    this.appUserService.SaveUserAgreeRecord({
      UserId: this.globalVariable.currentAccountInfo.staffId,
      ParaID: 'FIRST_LOGIN_CONSENT_ARTICLE',
      Platform: 'APP',
      IsConsent: true
    }).subscribe(res => {
      this.modalController.dismiss(type, 'save').then(() => {
      });
    });
  }

  ngOnInit() {
  }

}
